// noinspection DuplicatedCode
import { addLoginQueryParams } from '../utils/url';
import { Locker } from '../utils/locker';
import { windowOpen } from '../utils/window';
import { FbAdapter } from '../social/fb/adapter';
import { AccountView } from '../account-window/account-view';
import { executeLinkAuthMethod } from '../account-window/parts/execute-link-auth-method';
import { AuthMethod } from '../account-window/parts/auth-method';


export function initFbSdk(): void {
    try {
        window.app.fb_login = fbLoginButtonHandler;
    } catch (error) {
        console.warn('fb not initialized', error);
    }
}

function fbLoginButtonHandler() {
    const lockKey = 'fb:login';
    const locker = Locker.getInstance();
    if (!locker.setTempLock(lockKey, 5000)) {
        return;
    }

    try {
        callAppFbLoginProcess();
    } catch (error) {
        console.warn(error);
        locker.releaseLock(lockKey);
    }
}

function callAppFbLoginProcess() {
    let url;

    url = window.app.config.fb.oauth_url + window.location.search;
    url = addLoginQueryParams(url);
    windowOpen(url, 600, 600);
}

export function switchToFbAccountEventListener() {
    return switchToFbAccount();
}

export async function switchToFbAccount(isBigReward?: boolean): Promise<void> {
    const fbAdapter = new FbAdapter(window.app.config.fb.oauth_app_id);
    fbAdapter.initSdk();
    const hasLoginState = await fbAdapter.getIsLoggedIn();
    if (!hasLoginState) {
        const hasLogin = await fbAdapter.logIn();
        if (!hasLogin) {
            console.error('Can\'t login in Facebook', hasLogin);
            window.Sentry.captureException('Can\'t login in Facebook');
            AccountView.hideAccountLoadingState();
            return;
        }
    }

    const fbAuthData = await fbAdapter.getAuthData();

    if (!fbAuthData) {
        console.error('Facebook data is null', fbAuthData);
        window.Sentry.captureException('Facebook data is null');
        AccountView.hideAccountLoadingState();
        return;
    }

    executeLinkAuthMethod(AuthMethod.FB, {
        access_token: fbAuthData.accessToken
    }, isBigReward);
}
